import styled, { css } from 'styled-components';
import device from 'components/atoms/utils/device';

const template = styled.div`
  ${({ displayState }) => css`
    font-size: 12px;
    font-weight: 400;
    white-space: nowrap;
    margin-bottom: 3px;
    margin-left: ${displayState?.margin ?? '0px'};
    color: ${displayState.color}; 

    @media ${device.tablet} {
      font-size: 14px;
    }
  `}
`;

export default template